module.exports = __webpack_public_path__ + "img/workProcessData0.0a8dcf45.png";